module.exports = __webpack_public_path__ + "img/snake-screenshot.53baea55.png";